import { takeEvery, fork, put, all, call, delay } from "redux-saga/effects"

import {
  deleteUser,
  getUsers,
  postAddUser,
  putEditPasswordUser,
  putEditUser,
  putResetPasswordUser,
} from "helpers/services/user"
import {
  ADD_USER,
  DELETE_USER,
  EDIT_PASSWORD_USER,
  EDIT_USER,
  GET_USERS,
  RESET_PASSWORD_USER,
} from "./actionTypes"
import {
  getUsersSuccess,
  getUsersError,
  addUserSuccess,
  addUserError,
} from "./actions"
import {
  deleteUserError,
  deleteUserSuccess,
  editPasswordUserError,
  editPasswordUserSuccess,
  editUserError,
  editUserSuccess,
  resetPasswordUserError,
  resetPasswordUserSuccess,
} from "store/actions"

function* getUsersOnSaga() {
  try {
    const response = yield call(getUsers)
    yield delay(1000)
    if (response.users) {
      yield put(getUsersSuccess(response.users))
    } else {
      yield put(getUsersError(error))
    }
  } catch (error) {
    yield put(getUsersError(error))
  }
}

function* addUserOnSaga({ payload: { user } }) {
  try {
    const response = yield call(postAddUser, user)
    if (response.success) {
      yield put(addUserSuccess(response.message))
    } else {
      yield put(addUserError(response.message))
    }
  } catch (error) {
    yield put(addUserError(error.message))
  }
}

function* editUserOnSaga({ payload: { user } }) {
  try {
    const response = yield call(putEditUser, user)
    if (response.success) {
      yield put(editUserSuccess(response.message))
    } else {
      yield put(editUserError(response.message))
    }
  } catch (error) {
    yield put(editUserError(error.message))
  }
}

function* editPasswordUserOnSaga({ payload: { user } }) {
  try {
    const response = yield call(putEditPasswordUser, user)
    if (response.success) {
      yield put(editPasswordUserSuccess(response.message))
    } else {
      yield put(editPasswordUserError(response.message))
    }
  } catch (error) {
    yield put(editPasswordUserError(error.message))
  }
}

function* resetPasswordUserOnSaga({ payload: { user } }) {
  try {
    const response = yield call(putResetPasswordUser, user)
    if (response.success) {
      yield put(resetPasswordUserSuccess(response.message))
    } else {
      yield put(resetPasswordUserError(response.message))
    }
  } catch (error) {
    yield put(resetPasswordUserError(error.message))
  }
}

function* deleteUserOnSaga({ payload: { user } }) {
  try {
    const response = yield call(deleteUser, user)
    if (response.success) {
      yield put(deleteUserSuccess(response.message))
    } else {
      yield put(deleteUserError(response.message))
    }
  } catch (error) {
    yield put(deleteUserError(error.message))
  }
}

function* UsersSaga() {
  yield takeEvery(GET_USERS, getUsersOnSaga)
  yield takeEvery(ADD_USER, addUserOnSaga)
  yield takeEvery(EDIT_USER, editUserOnSaga)
  yield takeEvery(EDIT_PASSWORD_USER, editPasswordUserOnSaga)
  yield takeEvery(RESET_PASSWORD_USER, resetPasswordUserOnSaga)
  yield takeEvery(DELETE_USER, deleteUserOnSaga)
}

export default UsersSaga
